export default __webpack_public_path__ + "static/media/ELIKSIR-00242.4e9ebd6d.JPG";